<app-alert></app-alert>
<app-floating-tips></app-floating-tips>

<app-sidenav (collapseEmitter)='sidenavCollapsed($event)'></app-sidenav>

<div id='general-div' class='general-div'>
  <router-outlet (activate)="changeOfRoutes()"></router-outlet>
</div>